import {
  BasePlugin,
  BaseStats,
  mergePluginOption,
  EventHandler,
  EventIds,
  PageViewEvent,
  BaseEvent,
} from '@fpkg/stats-core';
import { JsErrorOpt } from './JsErrorPlugin';
import { onLoad, addSinglePageEvent, addWindowUnloadEvent, debounce } from '../utils';

/* pageview监控配置 */
export interface PageviewOpt {
  pageView?: boolean; // 是否开启pageview监控，默认：true
  pageLeave?: boolean; // 是否开启pageleave监控，默认：true
}

class PageSwitch {
  current_url: string;

  current_time: number;

  callback?: EventHandler<PageViewEvent>;

  constructor(callback?: EventHandler<PageViewEvent>) {
    this.callback = callback;
    this.current_url = window.location.href;
    this.current_time = Date.now();

    onLoad(() => {
      // 初始化页面访问
      this.handlerPageView(this.current_url);

      // 监听单页面切换，微应用项目下，一次切换子应用也会多次调用history api，所以这里做下防抖，避免数据异常
      addSinglePageEvent(
        debounce((last_url: string) => {
          if (last_url !== window.location.href) {
            const now = Date.now();

            this.handlerPageLeave(last_url, now - this.current_time);

            this.current_url = window.location.href;
            this.current_time = now;

            this.handlerPageView(this.current_url);
          }
        }, 500)
      );

      // 监听页面卸载事件
      addWindowUnloadEvent(() => {
        // 页面卸载时
        this.handlerPageLeave(this.current_url, Date.now() - this.current_time);
      });
    });
  }

  handlerPageView(url_path: string) {
    this.callback && this.callback({ event: EventIds.PageView, visible: true, url_path });
  }

  handlerPageLeave(url_path: string, duration: number) {
    this.callback &&
      this.callback({
        event: EventIds.PageLeave,
        visible: false,
        url_path,
        duration,
      });
  }
}

export default class PageViewPlugin implements BasePlugin {
  name = 'pageView';

  stats?: BaseStats;

  option: PageviewOpt = {
    pageView: true,
    pageLeave: true,
  };

  constructor(option: JsErrorOpt | null | boolean) {
    mergePluginOption(this.option, option);
  }

  reportPageView(url_path: string, microApp?: string) {
    if (this.option.pageView) {
      const reportData: BaseEvent = { event: EventIds.PageView, visible: true, url_path };
      if (microApp) {
        reportData.micro_app = microApp;
      }
      this.stats?.event(reportData);
    }
  }

  reportPageLevel(url_path: string, duration: number, microApp?: string) {
    let d = duration;
    if (duration! > 30 * 60 * 1000) {
      // 最大值为30分钟
      d = 30 * 60 * 1000;
    }
    if (this.option.pageLeave) {
      const reportData: BaseEvent = { event: EventIds.PageView, visible: true, url_path, duration: d };
      if (microApp) {
        reportData.micro_app = microApp;
      }
      this.stats?.event(reportData);
    }
  }

  setup(stats: BaseStats): void {
    this.stats = stats;

    try {
      // @ts-ignore
      // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
      const pageSwitch = new PageSwitch((event) => {
        if (event.visible) {
          // 页面访问
          this.reportPageView(event.url_path);
        } else {
          this.reportPageLevel(event.url_path, event.duration || 0);
        }
      });
    } catch (e) {
      console.log(e);
    }
  }
}
